import { Injectable } from '@angular/core';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class HttpCacheService {

  PREFIX = 'CACHE_';

  constructor(private localStorageService: LocalStorageService) { }

  set(key: string, data: any, ttlSeconds: number): void {
    const expires = Date.now() + ttlSeconds * 1000;
    const item = {
      data,
      expires
    };
    this.localStorageService.setItem(this.PREFIX + key, JSON.stringify(item));
  }

  get(key: string): any | null {
    const raw = this.localStorageService.getItem(this.PREFIX + key);
    if (!raw) return null;

    try {
      const item = JSON.parse(raw);
      if (Date.now() > item.expires) {
        this.localStorageService.removeItem(key);
        return null;
      }
      return item.data;
    } catch (e) {
      this.localStorageService.removeItem(key);
      return null;
    }
  }
}
